// Yields control back to the browser for one animation frame — insert
// periodically inside a long loop (e.g. every N iterations) to break it
// into cooperative chunks instead of one uninterrupted synchronous run.
// Without this, a panel's own open animation (a CSS height transition,
// see use_height_transition.js) freezes for however long the loop takes,
// since the animation needs the main thread free to paint intermediate
// frames just as much as any other UI interaction does.
export function yieldToFrame() {
  return new Promise(resolve => requestAnimationFrame(resolve));
}
